export const genderIdentifier = (gender) => {
    switch (gender) {
        case 'M':
            return 'Male';
        case 'F':
            return 'Female';
        case 'O':
            return 'Other';
        default:
            return '';
    }

}